import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppRoutes } from './app.routes';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Application Components
import { AppComponent } from './app.component';
import { CommunicationService } from './components/shared/communication.service';
import { DialogService } from 'primeng/dynamicdialog';

// Application services
import { BreadcrumbService } from './components/patient/shared/breadcrumb.service';
import { MenuService } from './components/patient/shared/app.menu.service';
import { MessageService} from 'primeng/primeng';

//eglobal services
import { DoctorBreadcrumbService } from './components/medical-profession/shared/breadcrumb.service';
import { DoctorMenuService } from './components/medical-profession/shared/app.menu.service';

import { AdService } from './services/ad.service';

// import { HomePageModule } from './components/home-page/home-page.module';
import { PrimengModule } from './primeng/primeng.module';
import { DoctorsModule } from './components/medical-profession/doctors/doctors.module';
import { PatientModule } from './components/patient/patient.module';
import { UnSavedChangesGuard } from './guards/un-saved-changes.guard';
import { OtherMedicalProfessionModule } from './components/medical-profession/other-medical-profession/other-medical-profession.module';
import { PortalHomeModule } from './components/portal-home/portal-home.module';
import { AuthPatientGuard } from './guards/auth-patient.guard';
import { AuthEgdGuard } from './guards/auth-egd.guard';
import { GlobalExceptionFilter } from './exception/global.exception.filter';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { Router } from '@angular/router';
import { SupportModule } from './components/medical-profession/support/support.module';
import { TooltipModule } from 'primeng/tooltip';
import { VendorModule } from './components/medical-profession/vendor/vendor.module';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { RestApi } from './shared/apiUrls';
import { VerifyProviderGuard } from './guards/verify-provider.guard';
import { EgdproviderGuard } from './guards/egdprovider.guard';




@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        AppRoutes,
        ReactiveFormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        // HomePageModule,
        PortalHomeModule,
        OverlayPanelModule,
        PatientModule,
        DoctorsModule,
        OtherMedicalProfessionModule,
        SupportModule,
        PrimengModule,
        TooltipModule,
        VendorModule
    ],
    declarations: [
        AppComponent,
        // FieldValidatorDirective,
    ],
    providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy }, //! hash
        // { provide: LocationStrategy, useClass: HashLocationStrategy }, // hash
        //{ provide: ErrorHandler, useClass: GlobalExceptionFilter },
        {
            provide: TraceService,
            deps: [Router]
        },
        {
            provide: ErrorHandler,
            useValue: createErrorHandler()
        },
        UnSavedChangesGuard,
        DatePipe,
        BreadcrumbService,
        MenuService,
        DoctorBreadcrumbService,
        DoctorMenuService,
        MessageService,
        AdService,
        CommunicationService,
        DialogService,
        AuthPatientGuard,
        VerifyProviderGuard,
        EgdproviderGuard,
        AuthEgdGuard,
        {
            provide: APOLLO_OPTIONS,
            useFactory: (httpLink: HttpLink) => {
                return {
                    cache: new InMemoryCache(),
                    link: httpLink.create({
                        uri: RestApi.Urls.GraphQL
                    }),
                };
            },
            deps: [HttpLink]
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(trace: TraceService) {}
}
